import { useEffect, useState } from "react";
import {
  SearchOutlined,
} from "@ant-design/icons";
import {
  Col,
  Input,
  Popconfirm,
  Row,
  Table,
  Tabs,
} from "antd";
import { map, get } from "lodash";

import service from "../../../../services/stemiService";
import { recordError } from "../../../../utils/logService";

import {
  CheckboxSwitchery,
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';
const ListOlympiadName = ({ hasUpdated, setHasUpdated, showModal }) => {

  const [actionLabel, setActionLabel] = useState("Activate");
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [olympiadNames, setOlympiadNames] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedOlympiadName, setSelectedOlympiadName] = useState({});
  const [activeOlympiadName, setActiveOlympiadName] = useState({});

  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  const sortDirections = ['ascend', 'descend', 'ascend'];
  const entity = "OlympiadName";
  let msg = "";

  useEffect(() => {
    if (hasUpdated === true) {
      getOlympiadNames();
    }
  }, [hasUpdated]);

  const getOlympiadNames = async () => {
    setSearchText("");
    setOlympiadNames([]);
    setLoading(true);

    try {
      const response = await service.getOlympiadNames();
      if (response && response.status === 200) {
        const { data } = response;
        const sorted = data.sort((a, b) => b.id - a.id);
        setOlympiadNames(sorted);
        setFilteredData(sorted);
        setTotal(data.length);
      }
      setLoading(false);
      setHasUpdated(false);
    } catch (error) {
      msg = util.parseMessage(Messages.GET_FAILURE, entity);
      openNotification("System failed to load STEMI olympiad Names", msg, Notify.ERROR
      );
      recordError(error);
    }
  };

  const handleActivation = async (record) => {
    const { id } = record;
    var action = record.enabled ? "deactivation" : "activation";
    try {
      const data = {
        uuid: record.uuid,
        active: !record.enabled,
      }
      const response = await service.activateOlympiadName(data);
      if (response && response.status === 200) {
        msg = util.parseMessage(Messages.DISABLE_SUCCESS, "Olympiad Name " + action);
        openNotification("Olympiad Name Action", msg, Notify.SUCCESS);
        getOlympiadNames();
        return;
      }

      msg = util.parseMessage(Messages.DISABLE_FAILURE, "Olympiad Name " + action);
      openNotification("Olympiad Name Action", msg, Notify.ERROR);
    } catch (error) {
      recordError(error);
      msg = util.parseMessage(Messages.DISABLE_FAILURE, "Olympiad Name " + action);
      openNotification("Olympiad Name Action", msg, Notify.ERROR);
    }
  };

  const onPageChange = (row) => {
    setPageSize(row.pageSize);
  };

  const handleInputChange = (e) => {
    const { value: searchValue } = e.target;
    setSearchText(searchValue);
    globalSearch(searchValue);
  };

  const globalSearch = (searchValue) => {
    if (searchText === "") {
      setFilteredData(olympiadNames);
      return;
    }

    const reg = new RegExp(
      searchValue.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"),
      "gi"
    );

    var _filteredData = map(olympiadNames, (record) => {
      const nameMatch = get(record, "name").match(reg);

      if (!nameMatch) {
        return null;
      }
      return record;
    }).filter((record) => record);

    setSearchText(searchValue);
    setFilteredData(_filteredData);
    setTotal(_filteredData.length);

  };

  const columns = [
    {
      title: "Olympiad Name",
      dataIndex: "name",
      key: "olympiad-Name1",
      showOnResponse: true,
      showOnDesktop: true,
      sortDirections: sortDirections,
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Active",
      dataIndex: "enabled",
      key: "active4",
      showOnResponse: true,
      showOnDesktop: true,
      sortDirections: sortDirections,
      render: (value) => (<CheckboxSwitchery checked={value} disabled={true} />),
      sorter: (a, b) => a.enabled.localeCompare(b.enabled),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      showOnResponse: true,
      showOnDesktop: true,
      render: (_, record) => {
        return (
          <>
            <a key={"astemi-oly-name-" + record.id} onClick={() => showModal(record, "Edit")} >Edit</a>
            {record.enabled && (
              <Popconfirm
                title="Are you sure you want to deactivate this name?"
                onConfirm={() => handleActivation(record)}
                // onCancel={() => cancel()}
                okText="Yes"
              >
                <a key={"stemi-oly-name-del-" + record.id} style={{ marginLeft: 10 }}>Deactivate</a>
              </Popconfirm>
            )}
            {!record.enabled && (
              <Popconfirm
                title="Are you sure you want to activate this name?"
                onConfirm={() => handleActivation(record)}
                // onCancel={() => cancel()}
                okText="Yes"
              >
                <a key={"stemi-oly-name-del-" + record.id} style={{ marginLeft: 10 }}>Activate</a>
              </Popconfirm>
            )}
          </>
        )
      },
    },
  ];

  return (
    <>
      <div>Olympiad Name List</div>
      <Row>
        <Col xs={24} md={8}>
          <Input
            placeholder="Search Olympiad Name"
            type="text"
            className="search-bar"
            onChange={handleInputChange}
            allowClear
            size="large"
            prefix={<SearchOutlined />}
          />
        </Col>
      </Row>
      <div className="space"></div>
      <Tabs className="" type="card" key="1" />
      <div className="space"></div>
      <Table
        columns={columns}
        loading={loading}
        dataSource={filteredData}
        rowKey={(record) => record.id}
        onChange={onPageChange}
        bordered
        size="middle"
        // pagination={{ pageSize: pageSize }}
        pagination={{
          // defaultCurrent: 1,
          // current: currentPage,
          // defaultPageSize: pageSize,
          total: total,
          pageSize: pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          // onChange: onPageChange,
          // pageSizeOptions: [2, 5, 10, 20, 50, 100],
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} ${total > 1 ? 'Names' : 'Name'}`,
        }}
      />
    </>
  );
};

export default ListOlympiadName;
